import cx from 'classnames'
import PropTypes from 'prop-types'

import {GroupedSpecsList} from './groupedSpecsList.js'
import {BASE_CLASS, LIST_TYPES, PADDINGLESS_CLASS, WITH_WRAPPER_CLASS} from './settings.js'
import {SpecsList} from './specsList.js'
import {useGroups} from './useGroups.js'
import {useSpecifications} from './useSpecifications.js'

const ListModelDetails = ({
  listType = LIST_TYPES.basic,
  groupedModelDetails = {},
  modelDetails = {},
  isPaddingless = false,
  withWrapper = true
}) => {
  const hasIconList = listType === LIST_TYPES.icon
  const specifications = useSpecifications(modelDetails).filter(Boolean)
  const groupedSpecifications = useGroups(groupedModelDetails).filter(Boolean)

  const containerClass = cx(BASE_CLASS, {
    [WITH_WRAPPER_CLASS]: withWrapper,
    [PADDINGLESS_CLASS]: isPaddingless
  })

  return (
    <div className={containerClass}>
      <SpecsList hasIconList={hasIconList} specifications={specifications} />
      <GroupedSpecsList groupedSpecifications={groupedSpecifications} listType={listType} hasIconList={hasIconList} />
    </div>
  )
}

ListModelDetails.displayName = 'ListModelDetails'
ListModelDetails.propTypes = {
  listType: PropTypes.oneOf(LIST_TYPES),
  groupedModelDetails: PropTypes.object,
  modelDetails: PropTypes.object,
  isPaddingless: PropTypes.bool,
  withWrapper: PropTypes.bool
}

export {LIST_TYPES as listTypes}

export default ListModelDetails
